import type {ReactElement} from 'react';
import {Modal} from '@Components/modal';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {useAppSelector} from '@/hooks';
import type {ShareSignupFormInTeamTogglerProps} from '@Components/share-signup-form-in-team-toggler';

const PANEL_ID = 'share-signup-form-in-team-panel';
export type ShareSignupFormInTeamModalProps = ShareSignupFormInTeamTogglerProps;

export default function ShareSignupFormInTeamModal(): ReactElement<any> {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.SHARE_SIGNUP_FORM_IN_MODAL];
  });

  const height = '200px';
  const width = '582px';

  return (
    <Modal modalId={MODALS_IDS.SHARE_SIGNUP_FORM_IN_MODAL} modalHeight={height} panelId={PANEL_ID} modalWidth={width}>
      <LazyPanel
        panelDirectoryName={PANEL_ID}
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openShareSignupFormInTeamModal = (props: ShareSignupFormInTeamModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.SHARE_SIGNUP_FORM_IN_MODAL,
      panelProps: props,
    })
  );
};
